import { CSSProperties } from 'react'
import MDEditor from '@uiw/react-md-editor'
import { IFaqArticle } from '../../faq.types'
import faqApi from '../../faq.api'
import faqEvents from '../../events/faq.events'
import ArticleSearchTagField from './components/ArticleSearchTagField'
import { NavLink } from 'react-router-dom'
import confirmServiceCtrl from '../../../../../services/ConfirmService/confirmService.ctrl'
import Card from '../../../../../shared/Cards/Card'
import EditButton from '../../../../../shared/Buttons/EditButton'
import TextField from '../../../../../shared/Forms/TextField'
import TrashButton from '../../../../../shared/Buttons/TrashButton'

interface IProps {
  style?: CSSProperties
  article: IFaqArticle
}

const ArticlePreviewSheet = (props: IProps) => {
  const handleRemove = () => {
    confirmServiceCtrl
      .requestConfirm({
        description: 'Подтвердите удаление статьи',
        title: 'Подтверждение',
        type: 'danger',
      })
      .then((r) => {
        if (r.response === 'confirm') {
          faqApi.deleteArticle(props.article.id).then((r) => {
            if (r.status === 'success') {
              faqEvents.articleRemoved(props.article.id)
            }
          })
        }
      })
  }

  return (
    <Card style={props.style} type='normal'>
      <div className='flex-lines'>
        <div className='inline-flex-gap' style={{ width: '100%', justifyContent: 'space-between' }}>
          <h2 className='text--caption-l' style={{ marginBottom: '0.5em' }}>
            Статья
          </h2>
          <div className='inline-flex-gap'>
            <TrashButton onClick={handleRemove} />
            <NavLink to={'/admin/knowledge-base/articles/edit/' + props.article.id}>
              <EditButton onClick={() => {}} />
            </NavLink>
          </div>
        </div>

        <TextField header='Заголовок'>{props.article.title}</TextField>
        <ArticleSearchTagField article={props.article} />
        <TextField header='Текст'>
          <MDEditor.Markdown source={props.article.text} style={{ whiteSpace: 'pre-wrap' }} />
        </TextField>
      </div>
    </Card>
  )
}

export default ArticlePreviewSheet
